import { render, staticRenderFns } from "./previewTemplate.vue?vue&type=template&id=553aa4e2&scoped=true"
import script from "./previewTemplate.vue?vue&type=script&lang=js"
export * from "./previewTemplate.vue?vue&type=script&lang=js"
import style0 from "./previewTemplate.vue?vue&type=style&index=0&id=553aa4e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553aa4e2",
  null
  
)

export default component.exports